export default "__VITE_ASSET__BKLmCxSQ__";